import React, { useState, useEffect } from "react";
import { Drawer } from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";

interface SettingsDrawerProps {
  externalSetOpen?: (
    setter: React.Dispatch<React.SetStateAction<boolean>>
  ) => void;
  children: React.ReactNode;
  internetSpeed: Number | any;
}

function SettingsDrawer({
  externalSetOpen,
  children,
  internetSpeed,
}: SettingsDrawerProps) {
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    if (externalSetOpen) {
      externalSetOpen(setDrawerOpen);
    }
  }, [externalSetOpen]);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => setDrawerOpen(false)}
      BackdropProps={{
        onClick: () => setDrawerOpen(false),
      }}
    >
      <div className="flex justify-between items-center w-full h-[3.125rem] cursor-pointer pr-2 pl-2 sm:pl-8 pt-2 border-b border-b-[#ddd]">
        <CancelOutlined
          onClick={() => setDrawerOpen(false)}
          fontSize="large"
          className="w-[2.875rem] h-full hover:opacity-60"
        />

        {internetSpeed !== null && <div>{internetSpeed} Mbps</div>}
      </div>
      {children}
    </Drawer>
  );
}

export default SettingsDrawer;
